// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscriptionPayment_container__LGlOm {
  background-color: #0d0e11;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  max-width: 100vw;
}

.subscriptionPayment_container__LGlOm > *:not(.subscriptionPayment_backgroundGlow__RISit) {
  position: relative;
  z-index: 1;
}

.subscriptionPayment_backgroundGlow__RISit {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
}

.subscriptionPayment_backgroundSvg__hz35Q {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 100%;
  min-width: 360px;
  min-height: 684px;
}

.subscriptionPayment_content__xcPSH {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 24px 16px 420px;
  position: relative;
  z-index: 1;
  min-height: 100vh;
  width: 100%;
  max-width: 100vw;
  box-sizing: border-box;
  overflow-x: hidden;
}

.subscriptionPayment_logoContainer__5QDU6 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 88px;
  height: 88px;
  overflow: hidden;
  position: relative;
}

.subscriptionPayment_logo__rkdDb {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.subscriptionPayment_socialProof__YLsZL {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.subscriptionPayment_socialProofContent__Ki8Z9 {
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: center;
  line-height: 16px;
  font-size: 12px;
  text-align: center;
}

.subscriptionPayment_socialProofNumber__-GQxc {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  background: linear-gradient(90deg, #00D4FF 0%, #7B61FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-variation-settings: 'CTGR' 0, 'wdth' 100;
}

.subscriptionPayment_socialProofText__H6ilj {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #ffffff;
  font-variation-settings: 'CTGR' 0, 'wdth' 100;
}
.subscriptionPayment_overlaynavgate__bLAXI{
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  z-index: 9;
}

.subscriptionPayment_paymentButtonContainer__o5eSH {
  display: flex;
  width: 360px;
  padding-bottom: 12px;
  padding-top: 12px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  background: linear-gradient(90deg, #0D0E11 0%, #2D1B00 50%, #0D0E11 100%);
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  max-width: 100%;
  box-sizing: border-box;
  z-index: 10;
}
.subscriptionPayment_paymentButtonContainerInner__oytzy{
  padding-left: 16px;
  padding-right: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  display: flex;
  gap: 12px;
}

.subscriptionPayment_paymentButton__hIGnK {
  display: flex;
  width: 360px;
  padding: 0 var(--Gap-spacing-24, 24px);
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  min-height: 56px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.80);
  background: linear-gradient(99deg, #00FF5E 0%, #00FFC3 101.74%);
  color: #000;
  max-width: 100%;
  box-sizing: border-box;
}

.subscriptionPayment_upiGroupIcon__U\\+X0v {
  width: 68px;
  height: 28px;
  flex-shrink: 0;
  object-fit: contain;
}

.subscriptionPayment_paymentButton__hIGnK:hover {
  opacity: 0.9;
}

.subscriptionPayment_paymentButton__hIGnK:active {
  opacity: 0.8;
}

.subscriptionPayment_paymentButton__hIGnK:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.subscriptionPayment_paymentSection__4kr4d {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  max-width: 500px;
  padding: 20px 0;
  background-color: #22242B;
  border-radius: 20px 20px 0 0;
  box-sizing: border-box;
  z-index: 10;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.4);
}

.subscriptionPayment_paymentTitle__GdTzZ {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #f3f4f6;
  margin: 0;
  width: 100%;
  padding: 0 20px;
}

.subscriptionPayment_paymentOptions__SqSbV {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding: 0 20px;
}

.subscriptionPayment_paymentOption__kuQbn {
  background-color: #353945;
  border-radius: 12px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s;
}

.subscriptionPayment_paymentOption__kuQbn:hover {
  opacity: 0.9;
}

.subscriptionPayment_paymentOption__kuQbn:active {
  opacity: 0.8;
}

.subscriptionPayment_paymentOptionLeft__2fxeg {
  display: flex;
  flex: 1 1;
  gap: 12px;
  align-items: center;
  min-width: 0;
}

.subscriptionPayment_paymentIcon__DZ4S3 {
  background-color: #f3f4f6;
  border-radius: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.subscriptionPayment_paymentIconWrapper__9Zx-j {
  background-color: #f3f4f6;
  border-radius: 8px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.subscriptionPayment_paymentIconImg__HE3vO {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
}

.subscriptionPayment_googlePayIcon__W8S3w {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #4285F4 0%, #34A853 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.subscriptionPayment_googlePayText__i2kRT {
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #ffffff;
  letter-spacing: 0.5px;
}

.subscriptionPayment_phonePeIcon__wFTgj {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #5F259F 0%, #7B2CBF 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.subscriptionPayment_phonePeText__GjQ9N {
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
}

.subscriptionPayment_otherUpiIcon__jlXcR {
  width: 100%;
  height: 100%;
  background: transparent;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.subscriptionPayment_upiTriangle1__2ppSS {
  position: absolute;
  width: 18px;
  height: 18px;
  background: #FF6B35;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  transform: rotate(-30deg);
  left: 6px;
  top: 6px;
}

.subscriptionPayment_upiTriangle2__wAp5J {
  position: absolute;
  width: 18px;
  height: 18px;
  background: #2bcb44;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  transform: rotate(30deg);
  right: 6px;
  top: 6px;
}

.subscriptionPayment_paymentOptionName__zsAWs {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #f3f4f6;
}

.subscriptionPayment_paymentOptionNameContainer__I6UoY {
  display: flex;
  gap: 8px;
  align-items: center;
}

.subscriptionPayment_quickestBadge__VXiYn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px 4px 6px;
  border-radius: 12px;
  background: linear-gradient(94deg, #01A81B 0%, #003909 100%);
}

.subscriptionPayment_flashIcon__j-sa0 {
  display: flex;
  width: 12px;
  height: 12px;
  padding: 0.531px 3.431px 0.429px 3.431px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.subscriptionPayment_quickestBadge__VXiYn span {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 500;
  font-size: 10px;
  font-style: normal;
  line-height: 12px;
  color: #ffffff;
  white-space: nowrap;
}

.subscriptionPayment_arrowIcon__9hyBA {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.subscriptionPayment_enterUpiButton__3KEjh {
  background: linear-gradient(99deg, #00FF5E 0%, #00FFC3 101.74%);
  border: 1px solid rgba(255, 255, 255, 0.80);
  border-radius: 16px;
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 24px;
  gap: 8px;
  width: 100%;
  cursor: pointer;
  transition: opacity 0.2s;
}

.subscriptionPayment_enterUpiButton__3KEjh:hover {
  opacity: 0.9;
}

.subscriptionPayment_enterUpiButton__3KEjh:active {
  opacity: 0.8;
}

.subscriptionPayment_enterUpiButton__3KEjh span {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  color: #000;
}

.subscriptionPayment_payButton__rB2Jb {
  background: linear-gradient(99deg, #00FF5E 0%, #00FFC3 101.74%);
  border: none;
  border-radius: 16px;
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 24px;
  gap: 8px;
  width: 100%;
  cursor: pointer;
  transition: opacity 0.2s;
  margin-top: 12px;
}

.subscriptionPayment_payButton__rB2Jb:hover {
  opacity: 0.9;
}

.subscriptionPayment_payButton__rB2Jb:active {
  opacity: 0.8;
}

.subscriptionPayment_payButton__rB2Jb:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.subscriptionPayment_payButton__rB2Jb span {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
  color: #0D0E11;
}

/* Mobile responsiveness - no gaps on smaller screens */
@media (max-width: 500px) {
  .subscriptionPayment_socialProof__YLsZL {
    width: 100%;
    max-width: 100%;
  }

  .subscriptionPayment_paymentButtonContainer__o5eSH {
    left: 0;
    right: 0;
    transform: none;
    max-width: 100%;
    width: 100%;
  }

  .subscriptionPayment_paymentButton__hIGnK {
    width: 100%;
    max-width: 100%;
  }

  .subscriptionPayment_paymentSection__4kr4d {
    left: 0;
    right: 0;
    transform: none;
    max-width: 100%;
    border-radius: 20px 20px 0 0;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/SubscriptionPayment/subscriptionPayment.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4DAA4D;EAC5D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;AACA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,yEAAyE;EACzE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sCAAsC;EACtC,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,+DAA+D;EAC/D,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAO;EACP,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8CAA8C;EAC9C,yBAAyB;EACzB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8CAA8C;EAC9C,wBAAwB;EACxB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,mBAAmB;EACnB,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+DAA+D;EAC/D,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,+DAA+D;EAC/D,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,OAAO;IACP,QAAQ;IACR,eAAe;IACf,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,OAAO;IACP,QAAQ;IACR,eAAe;IACf,eAAe;IACf,4BAA4B;EAC9B;AACF","sourcesContent":[".container {\n  background-color: #0d0e11;\n  min-height: 100vh;\n  position: relative;\n  overflow-x: hidden;\n  overflow-y: auto;\n  width: 100%;\n  max-width: 100vw;\n}\n\n.container > *:not(.backgroundGlow) {\n  position: relative;\n  z-index: 1;\n}\n\n.backgroundGlow {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.backgroundSvg {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100%;\n  height: 100%;\n  min-width: 360px;\n  min-height: 684px;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding: 24px 16px 420px;\n  position: relative;\n  z-index: 1;\n  min-height: 100vh;\n  width: 100%;\n  max-width: 100vw;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n.logoContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 88px;\n  height: 88px;\n  overflow: hidden;\n  position: relative;\n}\n\n.logo {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.socialProof {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n.socialProofContent {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  justify-content: center;\n  line-height: 16px;\n  font-size: 12px;\n  text-align: center;\n}\n\n.socialProofNumber {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 16px;\n  background: linear-gradient(90deg, #00D4FF 0%, #7B61FF 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-variation-settings: 'CTGR' 0, 'wdth' 100;\n}\n\n.socialProofText {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #ffffff;\n  font-variation-settings: 'CTGR' 0, 'wdth' 100;\n}\n.overlaynavgate{\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(6px);\n  z-index: 9;\n}\n\n.paymentButtonContainer {\n  display: flex;\n  width: 360px;\n  padding-bottom: 12px;\n  padding-top: 12px;\n  padding-left: 16px;\n  padding-right: 16px;\n  padding-top: 12px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  background: linear-gradient(90deg, #0D0E11 0%, #2D1B00 50%, #0D0E11 100%);\n  position: fixed;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  max-width: 100%;\n  box-sizing: border-box;\n  z-index: 10;\n}\n.paymentButtonContainerInner{\n  padding-left: 16px;\n  padding-right: 16px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  gap: 12px;\n}\n\n.paymentButton {\n  display: flex;\n  width: 360px;\n  padding: 0 var(--Gap-spacing-24, 24px);\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  border: none;\n  cursor: pointer;\n  transition: opacity 0.2s;\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 19px;\n  min-height: 56px;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.80);\n  background: linear-gradient(99deg, #00FF5E 0%, #00FFC3 101.74%);\n  color: #000;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.upiGroupIcon {\n  width: 68px;\n  height: 28px;\n  flex-shrink: 0;\n  object-fit: contain;\n}\n\n.paymentButton:hover {\n  opacity: 0.9;\n}\n\n.paymentButton:active {\n  opacity: 0.8;\n}\n\n.paymentButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.paymentSection {\n  position: fixed;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  width: 100%;\n  max-width: 500px;\n  padding: 20px 0;\n  background-color: #22242B;\n  border-radius: 20px 20px 0 0;\n  box-sizing: border-box;\n  z-index: 10;\n  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.4);\n}\n\n.paymentTitle {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 24px;\n  color: #f3f4f6;\n  margin: 0;\n  width: 100%;\n  padding: 0 20px;\n}\n\n.paymentOptions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n  padding: 0 20px;\n}\n\n.paymentOption {\n  background-color: #353945;\n  border-radius: 12px;\n  padding: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  border: none;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.paymentOption:hover {\n  opacity: 0.9;\n}\n\n.paymentOption:active {\n  opacity: 0.8;\n}\n\n.paymentOptionLeft {\n  display: flex;\n  flex: 1;\n  gap: 12px;\n  align-items: center;\n  min-width: 0;\n}\n\n.paymentIcon {\n  background-color: #f3f4f6;\n  border-radius: 8px;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.paymentIconWrapper {\n  background-color: #f3f4f6;\n  border-radius: 8px;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.paymentIconImg {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  border-radius: 8px;\n}\n\n.googlePayIcon {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, #4285F4 0%, #34A853 100%);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.googlePayText {\n  font-family: 'Roboto', sans-serif;\n  font-weight: 500;\n  font-size: 12px;\n  color: #ffffff;\n  letter-spacing: 0.5px;\n}\n\n.phonePeIcon {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, #5F259F 0%, #7B2CBF 100%);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.phonePeText {\n  font-family: 'Roboto', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  color: #ffffff;\n}\n\n.otherUpiIcon {\n  width: 100%;\n  height: 100%;\n  background: transparent;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.upiTriangle1 {\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  background: #FF6B35;\n  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n  transform: rotate(-30deg);\n  left: 6px;\n  top: 6px;\n}\n\n.upiTriangle2 {\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  background: #2bcb44;\n  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n  transform: rotate(30deg);\n  right: 6px;\n  top: 6px;\n}\n\n.paymentOptionName {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #f3f4f6;\n}\n\n.paymentOptionNameContainer {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.quickestBadge {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px 4px 6px;\n  border-radius: 12px;\n  background: linear-gradient(94deg, #01A81B 0%, #003909 100%);\n}\n\n.flashIcon {\n  display: flex;\n  width: 12px;\n  height: 12px;\n  padding: 0.531px 3.431px 0.429px 3.431px;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.quickestBadge span {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 500;\n  font-size: 10px;\n  font-style: normal;\n  line-height: 12px;\n  color: #ffffff;\n  white-space: nowrap;\n}\n\n.arrowIcon {\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.enterUpiButton {\n  background: linear-gradient(99deg, #00FF5E 0%, #00FFC3 101.74%);\n  border: 1px solid rgba(255, 255, 255, 0.80);\n  border-radius: 16px;\n  min-height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 24px;\n  gap: 8px;\n  width: 100%;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.enterUpiButton:hover {\n  opacity: 0.9;\n}\n\n.enterUpiButton:active {\n  opacity: 0.8;\n}\n\n.enterUpiButton span {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 16px;\n  color: #000;\n}\n\n.payButton {\n  background: linear-gradient(99deg, #00FF5E 0%, #00FFC3 101.74%);\n  border: none;\n  border-radius: 16px;\n  min-height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 24px;\n  gap: 8px;\n  width: 100%;\n  cursor: pointer;\n  transition: opacity 0.2s;\n  margin-top: 12px;\n}\n\n.payButton:hover {\n  opacity: 0.9;\n}\n\n.payButton:active {\n  opacity: 0.8;\n}\n\n.payButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.payButton span {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 20px;\n  color: #0D0E11;\n}\n\n/* Mobile responsiveness - no gaps on smaller screens */\n@media (max-width: 500px) {\n  .socialProof {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .paymentButtonContainer {\n    left: 0;\n    right: 0;\n    transform: none;\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .paymentButton {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .paymentSection {\n    left: 0;\n    right: 0;\n    transform: none;\n    max-width: 100%;\n    border-radius: 20px 20px 0 0;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `subscriptionPayment_container__LGlOm`,
	"backgroundGlow": `subscriptionPayment_backgroundGlow__RISit`,
	"backgroundSvg": `subscriptionPayment_backgroundSvg__hz35Q`,
	"content": `subscriptionPayment_content__xcPSH`,
	"logoContainer": `subscriptionPayment_logoContainer__5QDU6`,
	"logo": `subscriptionPayment_logo__rkdDb`,
	"socialProof": `subscriptionPayment_socialProof__YLsZL`,
	"socialProofContent": `subscriptionPayment_socialProofContent__Ki8Z9`,
	"socialProofNumber": `subscriptionPayment_socialProofNumber__-GQxc`,
	"socialProofText": `subscriptionPayment_socialProofText__H6ilj`,
	"overlaynavgate": `subscriptionPayment_overlaynavgate__bLAXI`,
	"paymentButtonContainer": `subscriptionPayment_paymentButtonContainer__o5eSH`,
	"paymentButtonContainerInner": `subscriptionPayment_paymentButtonContainerInner__oytzy`,
	"paymentButton": `subscriptionPayment_paymentButton__hIGnK`,
	"upiGroupIcon": `subscriptionPayment_upiGroupIcon__U+X0v`,
	"paymentSection": `subscriptionPayment_paymentSection__4kr4d`,
	"paymentTitle": `subscriptionPayment_paymentTitle__GdTzZ`,
	"paymentOptions": `subscriptionPayment_paymentOptions__SqSbV`,
	"paymentOption": `subscriptionPayment_paymentOption__kuQbn`,
	"paymentOptionLeft": `subscriptionPayment_paymentOptionLeft__2fxeg`,
	"paymentIcon": `subscriptionPayment_paymentIcon__DZ4S3`,
	"paymentIconWrapper": `subscriptionPayment_paymentIconWrapper__9Zx-j`,
	"paymentIconImg": `subscriptionPayment_paymentIconImg__HE3vO`,
	"googlePayIcon": `subscriptionPayment_googlePayIcon__W8S3w`,
	"googlePayText": `subscriptionPayment_googlePayText__i2kRT`,
	"phonePeIcon": `subscriptionPayment_phonePeIcon__wFTgj`,
	"phonePeText": `subscriptionPayment_phonePeText__GjQ9N`,
	"otherUpiIcon": `subscriptionPayment_otherUpiIcon__jlXcR`,
	"upiTriangle1": `subscriptionPayment_upiTriangle1__2ppSS`,
	"upiTriangle2": `subscriptionPayment_upiTriangle2__wAp5J`,
	"paymentOptionName": `subscriptionPayment_paymentOptionName__zsAWs`,
	"paymentOptionNameContainer": `subscriptionPayment_paymentOptionNameContainer__I6UoY`,
	"quickestBadge": `subscriptionPayment_quickestBadge__VXiYn`,
	"flashIcon": `subscriptionPayment_flashIcon__j-sa0`,
	"arrowIcon": `subscriptionPayment_arrowIcon__9hyBA`,
	"enterUpiButton": `subscriptionPayment_enterUpiButton__3KEjh`,
	"payButton": `subscriptionPayment_payButton__rB2Jb`
};
export default ___CSS_LOADER_EXPORT___;
